import React, { Component } from 'react';
import BsyAlertTextEdit from '../BsyAlertTextEdit';
import { BsyUtils } from "../../utils/Utils";
import BsyAlertQrcode from "../BsyAlertQrcode";

import './index.css'
import { BsyConfig } from '../../global/BsyConfig';
import BsyFormPane from '../BsyFormPane';
import BsyButton from '../BsyButton';
import QRCode from 'qrcode.react';
import tipAlert from '../../Login/BsyAlertTip/Staticize';
import i18next, { i18n } from 'i18next';
import { setPageTitle } from '../../utils/setPageTitle';
class BsyFormView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isPassPWD: window.FX.STATIC["HASPWD"],
            isLoading: true
        }
        this.renderIndex = 0;
    }
    openPWD = () => {
        BsyAlertTextEdit({
            title: React.language('external.link.password.form'),
            noCancel: true,
            width: 350,
            onOk: (val, t) => {
                React.axios(`${window.FX.STATIC["QTOKEN"]}/password`, { publicPwd: val }).then(() => {
                    this.setState({ isPassPWD: false }, () => {
                        this.loadFormViewData()
                        t.closeAlter();
                    });
                    return true;
                }).catch(() => {
                    return false;
                })
                return false;
            }
        })
    }

    componentDidMount() {
        window.FX.STATIC.VIP_PACK = null;
        BsyUtils.Vip._getPack();
        if (window.FX.STATIC.openweixin) {
            return;
        }

        if (!this.state.isPassPWD) {
            this.loadFormViewData()
        } else {
            this.setState({}, () => {
                this.openPWD()
            })
        }
    }

    loadFormViewData() {
        const FX = window.FX;
        let e = {};

        e.appId || BsyUtils.isEmpty(FX.STATIC.APPID) || (e.appId = FX.STATIC.APPID);
        e.entryId || BsyUtils.isEmpty(FX.STATIC.ENTRYID) || (e.entryId = FX.STATIC.ENTRYID);
        e.dataId || BsyUtils.isEmpty(FX.STATIC.DATAID) || (e.dataId = FX.STATIC.DATAID);
        FX.STATIC.BACKUP && (e.isBackup = !0);
        if (BsyUtils.isEmpty(FX.STATIC.DTOKEN)) {
            if (BsyUtils.isEmpty(FX.STATIC.FTOKEN)) {
                if (BsyUtils.isEmpty(FX.STATIC.QTOKEN)) {
                    if (BsyUtils.isEmpty(FX.STATIC.RTOKEN)) {
                        if (!BsyUtils.isEmpty(FX.STATIC.ATOKEN)) {
                            e.fx_access_token = FX.STATIC.ATOKEN
                            e.fx_access_type = "app_public"
                        }
                    } else {
                        e.fx_access_token = FX.STATIC.RTOKEN;
                        e.fx_access_type = "report_public"
                    }
                } else {
                    e.fx_access_token = FX.STATIC.QTOKEN;
                    e.fx_access_type = "form_query"
                }
            } else {
                e.fx_access_token = FX.STATIC.FTOKEN;
                e.fx_access_type = "form_public"
            }
        } else {
            e.fx_access_token = FX.STATIC.DTOKEN;
            e.fx_access_type = "form_public"
        }
        e.appId = FX.STATIC.APPID;


        React.axios(`/dashboard/app/${e.appId}/entry/${e.entryId}`, {
            appId: e.appId, entryId: e.entryId, fx_access_token: e.fx_access_token, fx_access_type: e.fx_access_type
        }).then((res) => {
            const h = res ? res.data.entry : {};
            setPageTitle(h.name)
            this.renderIndex++;
            this.setState({
                formConfig: {
                    ...h,
                    appId: h.appId,
                    entryId: h.entryId,
                },
                isLoading: false
            }, () => {
                // this.autoRefresh();
            })
        })
    }

    getContext = (context) => {
        this.bsyContext = context;
    }

    openQrcode = (event) => {
        event.stopPropagation()

        const pot = event.currentTarget.getBoundingClientRect()
        const css = 160 > (document.documentElement.clientHeight - pot.top + event.currentTarget.offsetHeight + 2) ? {
            left: pot.left - 160 + 'px',
            minWidth: event.currentTarget.offsetWidth,
            bottom: document.documentElement.clientHeight - pot.top + 2 + 'px'
        } : {
            left: pot.left - 160 + 'px',
            minWidth: event.currentTarget.offsetWidth,
            top: pot.top + event.currentTarget.offsetHeight + 2 + 'px'
        }
        BsyAlertQrcode({
            value: window.location.href,  //value参数为生成二维码的链接
            size: 160, //二维码的宽高尺寸
            css: css,

            text: React.language('msg.qrCode'),
            fgColor: "#000000"
        })
    }

    showOpenWeiXinView = () => {
        return <div style={{
            height: "100%",
            display: 'flex',
            flexDirection: 'column',
            alignItems: "center",
            justifyContent: "center",
        }}>
            <i className="icon-wechat css-s0dwjm"
                style={{
                    fontSize: 26,
                    color: "var(--bsy-base-color)",
                    marginBottom: 10,
                }}
            ></i>
            <p className="css-1msp6zp edb41h0" style={{ fontSize: 20 }}>
                {i18next.t("winxin.write")}
            </p>
            <div className="css-zol2i8 e1oi5x0g0">
                <div display="inline-flex" className="css-z4wykr e1oi5x0g0"
                    style={{
                        padding: 20,
                        background: "#fff",
                        margin: "10px 0"
                    }}
                >
                    <div className="adm-image" style={{
                        borderRadius: 4,
                        overflow: 'hidden',
                        // width: 240,
                        // height: 240,
                    }}>
                        <QRCode
                            fgColor={"#333"} //二维码的颜色
                            value={window.location.href} //value参数为生成二维码的链接
                            size={200} //二维码的宽高尺寸
                        />
                    </div>
                </div>
            </div>
            <BsyButton
                text={i18next.t("copy.form.link")}
                type="blue"
                click={(e) => {
                    BsyUtils.copyToClipboard(window.location.href, function () {
                        tipAlert({
                            type: "success",
                            msg: React.language("link.copySuccess")
                        })
                    })
                }}
            />

        </div >
    }

    render() {
        let { isPassPWD, isLoading, formConfig } = this.state;

        if (window.FX.STATIC.openweixin) {
            return this.showOpenWeiXinView();
        }

        let styles = {};
        if (!isLoading && formConfig) {


            if (!BsyUtils.isObjectEmpty(formConfig.theme)) {
                const { mode, system, custom } = formConfig.theme;
                let d = BsyConfig().THEME.EXTERNAL_FORM_THEME[system];
                if (mode !== 'system') {
                    d = { ...d, ...custom }
                }
                if (d.background.mode === 'color') {
                    styles.background = d.background.color;
                } else {
                    styles['backgroundSize'] = '100%';
                    styles['backgroundImage'] = 'url(' + d.background.image + ')';
                }
            }

        }
        if (formConfig) {
            formConfig.content.width = 1080;
            formConfig.Outside = true;
        }



        return (
            <div className="BsyFormView"
                style={styles}
            >
                {
                    !isPassPWD ? <div className="dashView-body"  >
                        {!isLoading ? <BsyFormPane
                            key={'byfr-' + this.renderIndex}
                            formConfig={formConfig}
                            buttonPosition={'middle'}
                            mode={"new"}
                            isLink={!0}
                            getContext={this.getContext}

                        /> : ''}
                        {
                            BsyUtils.createFooterLogo()
                        }
                    </div> : ''
                }

            </div>
        );
    }
}

export default BsyFormView;
